import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { Fragment, useMemo, useState } from 'react';

import BottomSheet from './BottomSheet';
import DropdownIcon from './DropdownIcon';

interface Props {
    title: string;
    options?: {value: string; label: string}[];
    value?: string;
    onChange?: (v: string) =>void;
}

function FilterOption({
    title, value, options, onChange,
}:Props) {
    const [isOpen, setIsOpen] = useState(false);
    const displayValue = useMemo(() => {
        if (value) {
            return options?.find((option) => option.value === value)?.label;
        }
        return title;
    }, [title, value, options]);
    return (<Fragment>
        <Container onClick={() => setIsOpen(true)}
            fullWidth
            justify='space-between'
            align='center'
            spacing={7} >
            <Text fontWeight='bold'>
                {displayValue}
            </Text>
            <DropdownIcon/>
        </Container>
        <BottomSheet isOpen={isOpen}
            options={options}
            onChange={onChange}
            close={() => setIsOpen(false)}
            title={title} />
    </Fragment>);
}

const Container = styled(Row)`
    padding: 12px 10px;
    border: 1px solid var(--color-gray5);
    border-radius: 8px;
`;

export default FilterOption;
